import { render } from "./App.vue?vue&type=template&id=13ba64b4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=13ba64b4&lang=scss"

import exportComponent from "/Users/maxime/Documents/Projects/Ombrage/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__